<div class="row">
  <div *ngIf="labelName" class="col-md-4 col-12">
    <label
      class="control-label"
      for="{{ labelName ? labelName : 'inputText' }}"
    >
      <span [ngClass]="required ? 'required' : 'hide'">*</span>
      {{ labelName }}
    </label>
  </div>
  <div [ngClass]="{ 'col-md-8 col-12': labelName, 'col-12': !labelName }">
    <input
      #inputText
      (blur)="emitBlur()"
      (ngModelChange)="changeModel($event)"
      [ngClass]="{
        requiredField: !isValid && !submitted && !isReadOnly,
        errorRequiredField: !isValid && submitted && !isReadOnly,
      }"
      [ngModel]="inputModel"
      [placeholder]="placeholder"
      class="form-control"
      id="{{ labelName ? labelName : 'inputText' }}"
      name="{{ labelName ? labelName : 'inputText' }}"
      type="text"
      [disabled]="isReadOnly"
    />
  </div>
  <pre *ngIf="environment.useDebugMode">
inputModel: {{ inputModel }}
    isValid {{ isValid }}</pre
  >
  <div
    *ngIf="submitted && !isValid && !isReadOnly"
    class="col-12 errorText"
    id="validationError"
  >
    <i class="fa fa-circle-o fa-lg circle-position"></i>
    <i class="fa fa-exclamation exclamation-position"></i>
    <p *ngIf="!errorMessage" class="col ps-2 ms-4 input-validation-text">
      Entry cannot be empty.
    </p>
    <p *ngIf="errorMessage" class="col ps-2 ms-4 input-validation-text">
      {{ errorMessage }}
    </p>
  </div>
  <div *ngIf="!submitted || isValid || isReadOnly" class="col-12">
    <p></p>
  </div>
</div>
